import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  checkoutLinkContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '4px 8px 4px 13px',
    '& a': {
      color: '#000',
      fontSize: 14,
      lineHeight: '24px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      maxWidth: 203,
      '&:hover': {
        textDecoration: 'underline',
      },
    },
    border: '1px solid #D9D9D9',
  },
}));
